import {RootState} from '@shared/types/rootState';
import {KeyValue} from '@shared/types/keyValue';

export default <T = unknown>(key: keyof KeyValue) =>
  (state: RootState): T | null =>
    state.keyvalue ? (state.keyvalue[key] as T) : null;
